import { render, staticRenderFns } from "./KnowledgeFeed.vue?vue&type=template&id=3495125d&"
import script from "./KnowledgeFeed.vue?vue&type=script&lang=js&"
export * from "./KnowledgeFeed.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/knowledgefeed.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports